// Найдите {plural(lines.length, ['слово', 'слова', 'слов'])}
export var plural = function (number, titles, titleOnly) {
    if (titleOnly === void 0) { titleOnly = false; }
    var cases = [2, 0, 1, 1, 1, 2];
    var title = titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]];
    return titleOnly ? title : number + ' ' + title;
};
